import React, { useState, useEffect, useRef } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer } from 'react-toastify';
import { ListsModal } from '../../contexts';
import AddEvent from '../../components/Modals/AddEvent';
import SendTxt from '../../components/Modals/SendTxt';
import SendEmail from '../../components/Modals/SendEmail';
// import Toolbar from '../../containers/Grid/Toolbar';

import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';

const Reviews = ( { aid, uid, canExport, reviews, load } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();

    let cols = [
        { field: 'headline', headerName: 'Headline', width: 150, renderCell: ( params ) => <Link to={`/review/${params.row.id}`}>{params.value}</Link> },
        { field: 'status', headerName: 'Status', width: 100 },
        { field: 'rating', headerName: 'Rating', width: 100 },
        { field: 'maxRating', headerName: 'Rating Scale', width: 100 },
        { field: 'requestDate', headerName: 'Request Date', type: 'date', width: 100, valueGetter: ( { value } ) => value && new Date( value ).toLocaleDateString() },
        { field: 'reviewDate', headerName: 'Review Date', type: 'date', width: 100, valueGetter: ( { value } ) => value && new Date( value ).toLocaleDateString() },
        { field: 'review', headerName: 'Review', width: 350 },
        { field: 'url', headerName: 'URL', width: 150 },
    ];

    const containerRef = useRef();
    const titleRef = useRef();
    const numbersRef = useRef();

    useEffect( () => {
        document.title = 'Third Floor - Reviews';
        load( { aid: aid, uid: uid } );

        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ aid, uid, load ] );
    
    const gridRef = useGridApiRef();

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center'>
                        <Col>
                            <Row className='text-start align-items-center'>
                                <Col xs='auto' className='pe-0'>
                                    <GridFooter className='tf-fake-footer' />
                                </Col>
                                <Col>
                                    { 
                                        selectedRows.length > 0 &&
                                        <Row style={ { borderLeft: '1px solid #CCC' } }>
                                            <Col xs='auto' className='pe-2'>Take Action...</Col>
                                            <Col xs='auto' className='ps-0'>
                                                <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent'>
                                                    <Dropdown.Item onClick={ () => handleModal( 'email' ) }>Email</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleModal( 'sms' ) }>Txt</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleModal( 'event' ) }>Add to an Event</Dropdown.Item>
                                                </DropdownButton>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col xs='auto' className='text-right'>
                            <GridToolbarQuickFilter />
                        </Col>
                        {
                            ( canExport ) ? (
                                <Col xs='auto' className='pe-3 text-right'>
                                    <GridToolbarExport />
                                </Col>
                            ) : (
                                null
                            )
                        }
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'email':
                setModal( <SendEmail /> );
                break;

            case 'sms':
                setModal( <SendTxt /> );
                break;

            case 'event':
                setModal( <AddEvent /> );
                break;

            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
        
        console.log( 'modal: ' + t );
    }

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: 'calc(100vh - 125px)' } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Reviews</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            loading={ reviews.length === 0 }
                                            rows={reviews}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { toolbar: toolbar } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                        />
                                    </ListsModal.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal show={show} onHide={closeModal} centered size='lg'>
                {modal}
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    canExport: state.user.canExport,
    reviews: state.reviews.all,
} );
  
const mapDispatch = ( dispatch ) => ( {
    load: dispatch.reviews.loadReviews
} );
  
export default connect( mapProps, mapDispatch )( Reviews );